import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { Form } from "sprout-ui-dom/dist/Form";
import styled from "styled-components";
import { ArrowBackIosOutlined } from "sprout-ui-icons";
import { themeGet } from "sprout-ui-theme";
import { usePostPage_UpdateItemMutation } from "sprout-graphql";
import { PopoverDialog, PopoverDialogContextualActionBar, PopoverDialogContextualActionBarCloseButton, PopoverDialogContextualActionBarSaveButton, PopoverDialogSaveButton } from "sprout-ui-dom/dist/PopoverDialog";
import { Editor as BaseEditor, useEditorRef } from "sprout-ui-dom";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import PopoverDialogContent from "./PopoverDialogContent";
const Editor = styled(BaseEditor)`
  color: ${themeGet("colors.black.87")};
  background: ${themeGet("colors.white.100")};
  border: 1px solid ${themeGet("colors.black.12")};
  border-radius: 8px;

  .ProseMirror {
    padding: 12px 16px;
  }

  margin-bottom: 16px;
`;
const DescriptionPopoverDialog = (props)=>{
    const { description , itemId , onOpenChange , triggerElement , referenceElement , onOutsideClick , open ,  } = props;
    const handleClose = useCallback(()=>{
        onOpenChange(false);
    }, [
        onOpenChange
    ]);
    const showSnackbar = useSnackbar();
    const [updatePost] = usePostPage_UpdateItemMutation();
    const handleSubmit = useCallback(({ text , link  })=>{
        if (!text.trim() && !link) {
            handleClose();
            return;
        }
        const isLink = link !== null && link.startsWith("http");
        updatePost({
            variables: {
                itemId,
                // items_check6
                description: text || (link ? isLink ? null : link : ""),
                // items_check7
                // We want to retain w/e the exiting link is, instead of removing it
                url: isLink ? link : undefined,
                includeNote: false,
                includeDescription: true,
                includeUrl: true
            }
        }).catch(()=>{
            showSnackbar.error();
        });
        handleClose();
    }, [
        handleClose,
        itemId,
        showSnackbar,
        updatePost
    ]);
    const handleEnter = useCallback(({ getStateAsText  })=>{
        const { text , link  } = getStateAsText();
        handleSubmit({
            text,
            link
        });
        return true;
    }, [
        handleSubmit
    ]);
    const handleEscape = useCallback(()=>{
        handleClose();
        return true;
    }, [
        handleClose
    ]);
    const editorRef = useEditorRef();
    const handleActionBarSave = useCallback(()=>{
        if (editorRef.current) {
            const { getStateAsText  } = editorRef.current;
            const { text , link  } = getStateAsText();
            handleSubmit({
                text,
                link
            });
        }
    }, [
        editorRef,
        handleSubmit
    ]);
    useEffect(()=>{
        if (open && editorRef.current) editorRef.current.focus();
    }, [
        editorRef,
        open
    ]);
    const handleOutsideClick = useCallback((event)=>{
        handleActionBarSave();
        if (onOutsideClick) onOutsideClick(event);
    }, [
        handleActionBarSave,
        onOutsideClick
    ]);
    return /*#__PURE__*/ _jsxs(PopoverDialog, {
        onOpenChange: onOpenChange,
        triggerElement: triggerElement,
        referenceElement: referenceElement,
        onOutsideClick: handleOutsideClick,
        placement: "bottom",
        open: open,
        children: [
            /*#__PURE__*/ _jsx(PopoverDialogContextualActionBar, {
                contextualTitle: "Description",
                leftAction: /*#__PURE__*/ _jsx(PopoverDialogContextualActionBarCloseButton, {
                    onClick: handleActionBarSave,
                    children: /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {})
                }),
                rightAction: /*#__PURE__*/ _jsx(PopoverDialogContextualActionBarSaveButton, {
                    onClick: handleActionBarSave
                })
            }),
            /*#__PURE__*/ _jsxs(PopoverDialogContent, {
                as: Form,
                onSubmit: handleActionBarSave,
                children: [
                    /*#__PURE__*/ _jsx(Editor, {
                        itemId: itemId,
                        initialState: description || undefined,
                        mode: "BASIC",
                        placeholder: "Description",
                        onEnter: handleEnter,
                        onEscape: handleEscape,
                        ref: editorRef
                    }),
                    /*#__PURE__*/ _jsx(PopoverDialogSaveButton, {
                        type: "submit",
                        children: "Done"
                    })
                ]
            })
        ]
    });
};
export default DescriptionPopoverDialog;
